import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { TemplateSample } from '../../interfaces/sample.interface';
import { TemplateSampleActions } from '../actions/template-sample.actions';

export interface TemplateSampleState extends EntityState<TemplateSample> {
  error: unknown;
  pending: boolean;
}

export const adapter: EntityAdapter<TemplateSample> = createEntityAdapter<TemplateSample>({
  selectId: (sample: TemplateSample): string => sample.id,
});

export const initialState: TemplateSampleState = adapter.getInitialState({
  error: null,
  pending: false,
});

export const TemplateSampleReducer = createReducer(
  initialState,
  on(TemplateSampleActions.loadSamples, (state) => {
    return {
      ...state,
      error: null,
      pending: true,
    };
  }),
  on(
    TemplateSampleActions.loadSamplesSuccess,
    (state, { samples }): TemplateSampleState =>
      adapter.upsertMany(samples, {
        ...state,
        error: null,
        pending: false,
      }),
  ),
  on(TemplateSampleActions.loadSamplesFailure, (state, { error }) => {
    return {
      ...state,
      error,
      pending: false,
    };
  }),


  on(TemplateSampleActions.loadSample, (state) => {
    return {
      ...state,
      error: null,
      pending: true,
    };
  }),
  on(
    TemplateSampleActions.loadSampleSuccess,
    (state, { sample }): TemplateSampleState =>
      adapter.upsertOne(sample, {
        ...state,
        error: null,
        pending: false,
      }),
  ),
  on(TemplateSampleActions.loadSampleFailure, (state, { error }) => {
    return {
      ...state,
      error,
      pending: false,
    };
  }),

  on(TemplateSampleActions.updateSample, (state) => {
    return {
      ...state,
      error: null,
      pending: true,
    };
  }),
  on(
    TemplateSampleActions.updateSampleSuccess,
    (state, { sample }): TemplateSampleState =>
      adapter.upsertOne(sample, {
        ...state,
        error: null,
        pending: false,
      }),
  ),
  on(TemplateSampleActions.updateSampleFailure, (state, { error }) => {
    return {
      ...state,
      error,
      pending: false,
    };
  }),

  on(TemplateSampleActions.createSample, (state) => {
    return {
      ...state,
      error: null,
      pending: true,
    };
  }),
  on(
    TemplateSampleActions.createSampleSuccess,
    (state, { sample }): TemplateSampleState =>
      adapter.upsertOne(sample, {
        ...state,
        error: null,
        pending: false,
      }),
  ),
  on(TemplateSampleActions.createSampleFailure, (state, { error }) => {
    return {
      ...state,
      error,
      pending: false,
    };
  }),

  on(TemplateSampleActions.delete, (state): TemplateSampleState => ({
      ...state,
      error: null,
      pending: true,
    }),
  ),
  on(TemplateSampleActions.deleteSuccess, (state, { id }): TemplateSampleState =>
      adapter.removeOne(id, {
        ...state,
        error: null,
        pending: false,
      }),
  ),
  on(TemplateSampleActions.deleteFailure, (state, { error }): TemplateSampleState => ({
      ...state,
      error,
      pending: false,
    }),
  ),

  on(TemplateSampleActions.bulkImport, (state): TemplateSampleState => ({
      ...state,
      error: null,
      pending: true,
    }),
  ),
  on(
    TemplateSampleActions.bulkImportSuccess,
    (state, { response }): TemplateSampleState =>
      adapter.upsertMany(response.createdSamples, {
        ...state,
        error: null,
        pending: false,
      }),
  ),
  on(TemplateSampleActions.bulkImportFailure, (state, { error }): TemplateSampleState => ({
      ...state,
      error,
      pending: false,
    }),
  ),

  on(TemplateSampleActions.clearSamples, (state) => adapter.removeAll(state)),
);

const { selectAll } = adapter.getSelectors();

export const selectAllTemplateSample = selectAll;

export const selectAllJob = selectAll;

export const reducer = (state: TemplateSampleState | undefined, action: Action) =>
  TemplateSampleReducer(state, action);
